import { SubscribeEntity } from "@/entities/cmb/subscribe/subscribeEntity";
import { EntityController, IRequest } from "@intasect/platform-core";
import { url_subscribe } from "@/controllers/cmb/subscribe/subscribeUrls";
export class SubscribeController extends EntityController<SubscribeEntity> {
    constructor(request: IRequest) {
        super(request, url_subscribe, "订阅列表");
    }
    static readonly entityName = "subscribe";
}
